/**
 * 認証関連の型定義
 */

/**
 * ユーザーロール定数オブジェクト
 */
export const UserRoleValues = {
    ADMIN: 'ADMIN',
    USER: 'USER',
    MANAGER: 'MANAGER',
} as const;

/**
 * ユーザーロール型
 */
export type UserRole = typeof UserRoleValues[keyof typeof UserRoleValues];

/**
 * プロファイル
 */
export interface Profile {
    id: string;
    email: string;
    name: string | null;
    role: UserRole;
    is_active: boolean;
    person_id?: string | null;
    person_name?: string | null;
    craftsman_id: string | null;
    created_at: string;
    updated_at: string;
}

export interface User {
    id: string;
    email: string;
    created_at: string;
    updated_at: string;
}

export interface Session {
    access_token: string;
    refresh_token: string;
    expires_at: number;
    expires_in: number;
    token_type: string;
    user: User;
}

export interface AuthState {
    user: User | null;
    session: Session | null;
    loading: boolean;
    error: string | null;
}

export interface LoginCredentials {
    email: string;
    password: string;
}

export interface SignUpCredentials {
    email: string;
    password: string;
    name?: string;
}

export interface AuthError {
    message: string;
    status?: number;
}

export interface AuthResponse {
    user: User | null;
    session: Session | null;
    error: AuthError | null;
}

